import {
	IDeleteWordingData,
	TLocalizationSelectedItem,
	TLocalizationSettingsMode,
	TTypeOfModalWindow,
} from './localizationContext';
import { IRestaurantLocalizationGroup, IUpdateRestaurantLocalization } from 'types';

export enum LocalizationActionsTypes {
	REFETCH_WORDINGS = 'REFETCH_WORDINGS',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_GROUP = 'SET_GROUP',
	SET_LANGUAGE = 'SET_LANGUAGE',
	REMOVE_WORDING = 'REMOVE_WORDING',
	TOGGLE_USE_CUSTOMER_SETTINGS = 'TOGGLE_USE_CUSTOMER_SETTINGS',
	ADD_INVALID_FIELD = 'ADD_INVALID_FIELD',
	CLEAR_INVALID_FIELDS = 'CLEAR_INVALID_FIELDS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	SET_DELETE_WORDING_DATA = 'SET_DELETE_WORDING_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_MODE = 'CHANGE_MODE',
	UPDATE_GROUPS = 'UPDATE_GROUPS',
}

interface IRefetchWordings {
	type: LocalizationActionsTypes.REFETCH_WORDINGS;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetAllData {
	type: LocalizationActionsTypes.SET_ALL_DATA;
	payload: {
		useCustomerSettings: boolean;
		groups: IRestaurantLocalizationGroup[];
	};
}

interface ISetGroup {
	type: LocalizationActionsTypes.SET_GROUP;
	payload: {
		group: TLocalizationSelectedItem | null;
	};
}

interface ISetLanguage {
	type: LocalizationActionsTypes.SET_LANGUAGE;
	payload: {
		language: TLocalizationSelectedItem | null;
	};
}

interface IRemoveWording {
	type: LocalizationActionsTypes.REMOVE_WORDING;
	payload: {
		updatedGroups: IRestaurantLocalizationGroup[];
	};
}

interface IToggleUseCustomerSettings {
	type: LocalizationActionsTypes.TOGGLE_USE_CUSTOMER_SETTINGS;
}

interface IAddInvalidField {
	type: LocalizationActionsTypes.ADD_INVALID_FIELD;
	payload: {
		invalidField: string;
	};
}

interface IClearInvalidFields {
	type: LocalizationActionsTypes.CLEAR_INVALID_FIELDS;
}

interface ISetDataForSubmit {
	type: LocalizationActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: IUpdateRestaurantLocalization | null;
	};
}

interface ISetDeleteWordingData {
	type: LocalizationActionsTypes.SET_DELETE_WORDING_DATA;
	payload: {
		deleteWordingData: IDeleteWordingData | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: LocalizationActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeMode {
	type: LocalizationActionsTypes.CHANGE_MODE;
	payload: {
		mode: TLocalizationSettingsMode;
	};
}

interface IUpdateGroups {
	type: LocalizationActionsTypes.UPDATE_GROUPS;
	payload: {
		updatedGroups: IRestaurantLocalizationGroup[];
	};
}

export type TLocalizationAction =
	| IRefetchWordings
	| ISetAllData
	| ISetGroup
	| ISetLanguage
	| IRemoveWording
	| IToggleUseCustomerSettings
	| IAddInvalidField
	| IClearInvalidFields
	| ISetDataForSubmit
	| ISetDeleteWordingData
	| IChangeTypeOfModalWindow
	| IChangeMode
	| IUpdateGroups;
